<template>
  <panel :title="detailsTask" :withBody="false" :withFooter="false" :to="{ name: 'task', params: { identifier: task._id.$oid } }">
    <div slot="header-right">
      <span :class="task.status" class="badge">{{ $t(`batch.statuses.${task.status}.label`) }}</span>

      <div class="form-flex">
        <drop>
          <button class="btn" slot="trigger">
            Ações <i class="i-caret i-caret--light"></i>
          </button>

          <drop-content slot="content" placement="bottom-end">
            <ul class="c-nav c-nav--menus">
              <slot/>
            </ul>
          </drop-content>
        </drop>
      </div>
    </div>

    <progress class="progress progress--sm" :value="percent / 100" slot="floor" v-if="task.status === 'processing'"></progress>
  </panel>
</template>

<script>
  import Panel from '@/components/template/Panel'
  import moment from 'moment'

  export default {
    props: {
      task: {
        type: Object,
        required: true
      }
    },
    computed: {
      detailsTask () {
        const created = moment(this.task.created).format('DD/MM/YYYY HH:mm')
        return `${this.$t(`tasks.${this.task.identifier}.label`)} - ${this.$t(`${this.task.module.type}.label`)} ${this.$t(`${this.task.module.identifier}.label`)} em ${created}`
      },
      percent () {
        return ((this.task.totalItems - Object.keys(this.task.items).length) * 100) / this.task.totalItems
      }
    },
    components: {
      Panel
    }
  }
</script>

<style lang="sass"scoped>
  i
    color: #808080

  .form-flex
    display: inline

  .progress
    margin: 0
    -webkit-border-radius: 0
    -moz-border-radius: 0
    border-radius: 0

  .product
    border: 0

  .progress[value]::-ms-fill
    border: none
    background-color: #800080 !important

  .progress[value]::-webkit-progress-bar
    background-color: #f2f2f2

  .progress[value]::-webkit-progress-value
    background-color: #800080 !important

  .progress[value]::-moz-progress-bar
    background-color: #800080 !important
</style>



// WEBPACK FOOTER //
// TaskCard.vue?1baab97f